import { useState } from 'react';

import endpoints from '../../../../../../../../../api/endpoints';
import { BusinessError } from '../../../../../../../../common/business-error';
import { handleResponseError } from '../../../../../../../../../api/handleResponseError';
import { addParams, fetchWithTokenRefresh } from '../../../../../../../../../api/fetchWithTokenRefresh';

import { OtpValue } from '../interfaces';
import { getOtpVerifyBusinessError } from '../businessErrors';

type DialogError = BusinessError | null;

export const useOtpVerify = () => {
  const [otpVerifyLoading, setLoading] = useState<boolean>(false);
  const [otpVerifyError, setError] = useState<DialogError>(null);

  const handleOtpVerify = async (otp: OtpValue, onSuccess: () => void) => {
    try {
      setLoading(true);
      setError(null);

      const response = await fetchWithTokenRefresh(endpoints.clientSettingsUpdateConfirm, addParams('POST', { otp }));

      if (response.status !== 204) {
        await handleResponseError(response);
      }

      onSuccess();
      setLoading(false);
    } catch (e) {
      const { message, severity } = getOtpVerifyBusinessError(e);

      setError({ message, severity });
      setLoading(false);
    }
  };

  return { otpVerifyError, otpVerifyLoading, handleOtpVerify };
};
